// this is an autogenerated file from App/Account/Content/Settings/Content/NoteTemplates/Templates/Location/LocationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_NoteTemplates_Templates_Location_LocationChooser{
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    text: name
  }
}

`